import React from "react";

const RetryIcon = ({ color }: { color: string }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
  >
    <path
      d="M0.799805 0.801497V5.30097H1.32354M1.32354 5.30097C1.92094 3.82346 2.99166 2.5859 4.36791 1.78226C5.74416 0.978609 7.34816 0.654286 8.92852 0.860117C10.5089 1.06595 11.9763 1.7903 13.1008 2.91965C14.2253 4.049 14.9433 5.51952 15.1423 7.10076M1.32354 5.30097H5.29928M15.1981 15.1998V10.7003H14.6753M14.6753 10.7003C14.077 12.177 13.006 13.4136 11.6299 14.2165C10.2538 15.0194 8.65025 15.3434 7.07036 15.1376C5.49047 14.9318 4.0234 14.208 2.89884 13.0794C1.77427 11.9508 1.05569 10.4812 0.855598 8.90055M14.6753 10.7003H10.6986"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default RetryIcon;
